import comp from "./WithOnlySettingStep";
export default comp;
